import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiClient, extractApiError } from '../../api/axios';
import { API } from '../../constants/api';
import { DEFAULT_PAGE_SIZE } from '../../constants/ui';

const initialState = {
  requestData: [],
  reqId: '',
  changeInfoModal: null,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  total: null,

  loading: false,
  error: '',
  requests: [],

  statusPatchApplication: 'idle',
  errorPatchApplication: '',

  update: false,
};

export const fetchApplications = createAsyncThunk(
  'applications/fetchApplications',
  async ({ page, ...filter }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(API.orders.applications, { params: { page, ...filter } });
      return response.data;
    } catch (error) {
      return rejectWithValue(extractApiError(error));
    }
  }
);

export const patchApplication = createAsyncThunk(
  'applications/patchApplication',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiClient.put(API.orders.applicationById(id), data);
      return response.data;
    } catch (error) {
      return rejectWithValue(extractApiError(error));
    }
  }
);

export const requestsSlice = createSlice({
  name: 'applications',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchApplications.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchApplications.fulfilled, (state, action) => {
      state.loading = false;
      state.page = action.payload.page;
      state.pageSize = action.payload.page_size;
      state.total = action.payload.total;
      state.requests = action.payload.results;
    });
    builder.addCase(fetchApplications.rejected, (state, action) => {
      toast.error(action.payload);
      state.error = action.payload;
      state.loading = false;
      state.success = false;
    });

    builder.addCase(patchApplication.pending, (state) => {
      state.statusPatchApplication = 'loading';
    });
    builder.addCase(patchApplication.fulfilled, (state) => {
      state.statusPatchApplication = 'success';
    });
    builder.addCase(patchApplication.rejected, (state, action) => {
      state.statusPatchApplication = 'fail';
      state.errorPatchApplication = action.payload;
    });
  },
  reducers: {
    setRequestData: (state, { payload }) => {
      state.requestData = payload;
    },
    setReqId: (state, { payload }) => {
      state.reqId = payload;
    },
    setChangeInfoModal: (state, { payload }) => {
      state.changeInfoModal = payload;
    },
    setUpdate: (state) => {
      state.update = !state.update;
    },
    resetStatus: (state) => {
      state.statusPatchApplication = 'idle';
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
  },
});

export const { setPage, setRequestData, setReqId, setChangeInfoModal, resetStatus, setUpdate } = requestsSlice.actions;

export default requestsSlice.reducer;
